import { DotMatrix, PageHeader } from '@clickguard/design-system'
import { useAccountStore, useUiStore } from 'store'
import { sanitizeURL } from 'utils'
import { PageTitle } from '../../../../utils/page-title'
import { useShallow } from 'zustand/react/shallow'
import { lazy, Suspense } from 'react'
import { DeleteAccount } from '../../settings/delete-account'

const PreferencesFormSection = lazy(() =>
	import('./preferences-form-section')
		.then((module) => {
			return { default: module.PreferencesFormSection }
		})
		.catch((error) => {
			console.error('Failed to load:', error)
			return { default: () => <div>Error loading the component.....</div> }
		})
)
const PreferencesContactSection = lazy(() =>
	import('./preferences-contact-section')
		.then((module) => {
			return { default: module.PreferencesContactSection }
		})
		.catch((error) => {
			console.error('Failed to load:', error)
			return { default: () => <div>Error loading the component.....</div> }
		})
)
export const PreferencesSettingsPage = () => {
	const isLoading = useUiStore((s) => s.isLoading)
	const { account } = useAccountStore(
		useShallow((s) => {
			return {
				account: s.account
			}
		})
	)
	return (
		<div className="w-full">
			<PageTitle pageName="Workspace preferences" />
			<PageHeader
				layout="stacked"
				title={'Workspace preferences'}
				subtitle={
					<span className="inline-flex items-center">
						Configure basic preferences and contact details for&nbsp;
						<span className="!font-semibold max-w-[200px] truncate">
							{sanitizeURL(account?.name)}
						</span>
					</span>
				}
			/>
			{isLoading('ACCOUNT_SAVE_SETTINGS') ? (
				<div className="absolute top-0 bottom-0 left-0 right-0 z-100 flex items-center justify-center bg-white opacity-90">
					<DotMatrix size="lg" />
				</div>
			) : (
				<div className="pt-4">
					<>
						<Suspense
							fallback={
								<div className="flex justify-center py-16">
									<DotMatrix size="lg" />
								</div>
							}
						>
							<PreferencesFormSection />
						</Suspense>
						<Suspense
							fallback={
								<div className="flex justify-center py-16">
									<DotMatrix size="lg" />
								</div>
							}
						>
							<PreferencesContactSection />
						</Suspense>
						<DeleteAccount />
					</>
				</div>
			)}
		</div>
	)
}
